import { ActionIcon, Tooltip, VisuallyHidden } from "@mantine/core";
import { Volume2, VolumeOff, VolumeX } from "lucide-react";

import type { Composer } from "../composer/use-composer";
import classes from "./sound.module.css";

/** Live's words for a model that makes silent video only (L07). */
const SILENT = "Video will be generated without audio";

/**
 * Live's sound switch, by the draft's type's audio mode (G6): a switch where the model makes
 * sound or not ("Audio on", "Audio off"); locked on, disabled and grey, where it always makes
 * sound (capture 18); and a muted speaker on light indigo, not a control, where it makes silent
 * video only. The tooltip names the state. The draft's sound follows the lock (draft.ts).
 */
export function SoundToggle({ c }: { c: Composer }) {
  const audio = c.video?.modes[c.type.id]?.audio;
  if (audio === undefined) return null;
  if (audio === "none") {
    return (
      <Tooltip label={SILENT} withArrow>
        <span className={classes.silent}>
          <VolumeX size={20} strokeWidth={1.5} aria-hidden />
          <VisuallyHidden>{SILENT}</VisuallyHidden>
        </span>
      </Tooltip>
    );
  }
  const on = audio === "always" || c.draft.audio;
  return (
    <Tooltip label={on ? "Audio on" : "Audio off"} withArrow>
      {/* A disabled button takes no hover, so the tooltip hangs from its wrapper, as live's. */}
      <span className={classes.wrapper}>
        <ActionIcon
          variant="subtle"
          size="md"
          radius={8}
          className={classes.toggle}
          aria-label={on ? "Disable audio" : "Enable audio"}
          disabled={audio === "always"}
          onClick={() => c.set({ audio: !c.draft.audio })}
        >
          {on ? (
            <Volume2 size={20} strokeWidth={1.5} aria-hidden />
          ) : (
            <VolumeOff size={20} strokeWidth={1.5} aria-hidden />
          )}
        </ActionIcon>
      </span>
    </Tooltip>
  );
}
